<template>
  <section class="page-dashbord-rules mt-4">
    <div class="tabs-about-madya mb-4">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <b-card no-body>
              <b-tabs card pills v-model="tabIndex">
                 <b-tab title="راهنمای تدریس">
                  <div class="content">
                    <div class="description-tab">
                      <p>لطفا قبل از ادامه فرایند تعریف دوره نکات ضروری زیر و فایل راهنمای مدرسین و موسسات آموزشی، PDF ضمیمه را حتما مطالعه نمایید، تا با گزینه های پیش رو در تعریف دوره، نحوه تعریف دوره و نحوه رفع ایرادات احتمالی آشنا شوید.</p>
                      <ul>
                        <li>حتما برای دوره خود یک ویدئو معرفی ضبط نمایید، این ویدئو را بعنوان اولین قسمت دوره خود آپلود نمایید. اولین قسمت هر دوره بصورت رایگان برای همه کاربران به نمایش در می آید.</li>
                        <li>برای ضبط دوره خود از صفحه مانیتور رایانه می توانید از نرم افزار Camtasia Studio استفاده نمایید. خروجی نهایی ویدئو ها حداقل با کیفیت 
                          <b class="d-inline-block" dir="ltr"> 720 P</b>
                           باشد.</li>
                        <li>استفاده از یک میکروفن خارجی برای افزایش کیفیت صدای محتواهای ضبط شده توصیه می گردد.</li>
                        <li>بعد از ضبط ویدئو ها حتما مجدد ویدئو ها را بازبینی و ویرایش نمایید. تا اشکالات احتمالی رفع گردد.</li>
                        <li>
                          نمونه فایل پاورپوینت و لوگو مادیا جهت درج در ویدئو های آموزشی ضبط شده را می توانید از
                          <a href="/static/file/Teachers_Files.zip" download>
                            <span>اینجا</span> 
                          </a>دانلود نمایید.
                        </li>
                        <li>
                          برای راحتی تعریف دوره می توانید از فرم اطلاعات دوره استفاده نمایید. این فرم را می توانید از
                          <a href="/static/file/Teachers_Files.zip" download>
                          <span>اینجا</span></a>دانلود نمایید
                        </li>
                        <li>از درج لوگوی سایر سایت ها و قرار دادن تبلیغات در ویدئوهای آپلود شده خودداری فرمایید.</li>
                        <li>بعد از ارسال نهایی دوره و پس از بازبینی نهایی دوره توسط تیم مادیا، دوره در سایت منتشر می گردد.</li>
                      </ul>
                      <p>فایل های ضمیمه:</p>
                      <ul>
                        <li>
                           <a href="/static/file/Teachers_Files.zip" download>فایل های ضروری مدرسین (فرم اطلاعات دوره، پاورپوینت نمونه و لوگو مادیا)</a>
                        </li>
                        <li>
                            <a href="/static/file/Teachers-and-Educational-Institutions-Guide-V2.pdf" download>فایل راهنمای تعریف دوره مدرسین و موسسات آموزشی</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </b-tab>
                <b-tab  title=" تعرفه همکاری با مدرسین">
                  <div class="content d-flex">
                    <div class="table-responsive-lg">
                      <table class="table table-striped text-center rtl font-16">
                        <thead>
                          <tr>
                            <th>نحوه همکاری</th>
                            <th>توضیحات</th>
                            <th>سهم از درآمد</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td class="align-middle">رایگان</td>
                            <td class="align-middle">رایگان</td>
                            <td class="align-middle">---</td>
                          </tr>
                          <tr>
                            <td class="w-25 align-middle">فروش عادی</td>
                            <td
                              class="align-middle"
                            >- مدرس علاوه بر مادیا در وب سایت خود یا سایر وب سایت ها اقدام به عرضه محصول آموزشی نماید.</td>
                            <td class="w-25 text-center align-middle">
                              <span class="d-block">50% مدرس</span>
                              <span class="d-block">50% مادیا</span>
                            </td>
                          </tr>
                          <tr>
                            <td class="w-25 align-middle">فروش عادی ویژه</td>
                            <td
                              class="align-middle"
                            >- مدرس علاوه بر مادیا در وب سایت خود یا سایر وب سایت ها اقدام به عرضه محصول آموزشی نماید. - کاربران محصول آموزشی را توسط کوپن های تخفیف صادر شده توسط مدرس خرید نمایند.</td>
                            <td class="w-25 text-center align-middle">
                              <span class="d-block">70% مدرس</span>
                              <span class="d-block">30% مادیا</span>
                            </td>
                          </tr>
                          <tr>
                            <td class="w-25 align-middle">فروش انحصاری</td>
                            <td
                              class="align-middle"
                            >- مدرس انحصارا محصول آموزشی را در مادیا عرضه نماید.</td>
                            <td class="w-25 text-center align-middle">
                              <span class="d-block">70% مدرس</span>
                              <span class="d-block">30% مادیا</span>
                            </td>
                          </tr>
                          <tr>
                            <td class="w-25 align-middle">فروش انحصاری ویژه</td>
                            <td
                              class="align-middle"
                            >- کاربران محصول آموزشی را توسط کوپن های تخفیف صادر شده توسط مدرس خرید نمایند.</td>
                            <td class="w-25 text-center align-middle">
                              <span class="d-block">90% مدرس</span>
                              <span class="d-block">10% مادیا</span>
                            </td>
                          </tr>
                          <tr>
                            <td class="w-25 align-middle">فروش با تخفیف (عادی-انحصاری)</td>
                            <td class="align-middle">فروش با تخفیف (عادی-انحصاری)</td>
                            <td class="w-25 text-center align-middle">
                              <span class="d-block">تا 50% تخفیف</span>
                              <span class="d-block">25% مدرس</span>
                              <span class="d-block">25% مادیا</span>
                            </td>
                          </tr>
                          <tr>
                            <td class="w-25 align-middle">برنامه های تبلیغاتی (عادی-انحصاری)</td>
                            <td class="align-middle">برنامه های تبلیغاتی (عادی-انحصاری)</td>
                            <td class="w-25 text-center align-middle">
                              <span class="d-block">تا 50% تخفیف</span>
                              <span class="d-block">25% مدرس</span>
                              <span class="d-block">25% مادیا</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-tab>
                <b-tab title="همکاری با مادیا">
                  <div class="content d-flex flex-column">
                    <p class="font-16 text-right">
                      <i class="d-inline flaticon-check-square text-info"></i>
                      اگر فکر می‌کنید توانایی تولید بهترین فیلم‌های آموزشی در رشته تحصیلی، تخصص، حرفه و یا علاقه‌مندی‌های خود رادارید،
                    </p>
                    <p class="font-16 text-right">
                      <i class="d-inline flaticon-check-square text-info"></i>
                      اگر به دنبال اشتراک دانش خود هستید،
                    </p>
                    <p class="font-16 text-right">
                      <i class="d-inline flaticon-check-square text-info"></i>
                      اگر به فکر دیده شده در بین میلیون ها مخاطب هستید،
                    </p>
                    <p class="font-16 text-right">
                      <i class="d-inline flaticon-check-square text-info"></i>
                      گر به فکر درآمد زایی از فیلم‌های آموزشی هستید، و اگر به دنبال تبدیل کردن علم خود به ثروت هستید،
                    </p>
                    <p class="font-16 text-right">
                      <i class="d-inline flaticon-check-square text-info"></i>
                      مادیا انتخاب صحیحی برای شماست،
                    </p>
                    <p class="font-16 text-right">
                      <i class="d-inline flaticon-check-square text-info"></i>
                      مادیا با آماده کردن بستری مناسب تحت وب این امکان را به شما می‌دهد تا شما دغدغه‌های فروش، بازاریابی و ارائه محتوای خود به مخاطبین را نداشته باشید.
                    </p>
                    <p class="font-16 text-right">
                      <i class="d-inline flaticon-check-square text-info"></i>
                      این سیستم مشابه سایت های معتبر دنیا در عرصه آموزش آنلاین می باشد، بدین صورت که آموزش های شما بصورت آنلاین بر روی سایت قابل پخش می باشد و کاربران با استفاده از رایانه، تبلت و یا گوشی های هوشمند خود همیشه و همه جا می توانند فیلم های آموزشی شما را خرید و مشاهده نمایند
                    </p>
                    <p class="font-16 text-right">
                      <i class="d-inline flaticon-check-square text-info"></i>
                      هم اکنون می‌توانید فرم همکاری در تدریس را کامل نمایید و با رعایت استانداردهای ارائه‌شده برای تولید فیلم‌های آموزشی شروع به تولید و ارائه اولین فیلم آموزشی خود نمایید.
                    </p>
                  </div>
                </b-tab>
                <b-tab title="استاندارد های کیفیت و تولید محتوا">
                  <div class="content">
                    <div class="d-flex">
                      <header>
                        <h4
                          class="rtl text-right font-14"
                        >این چک لیست به تمام معیارهایی اشاره می کند که لازم است در دوره هایتان رعایت کنید تا مورد تائید مادیا قرار گیرد.</h4>
                      </header>
                    </div>
                    <ul class="clearfix rtl text-right lis-tabs-standard">
                      <li>
                        <b v-b-toggle.collapse1>
                          <toggle-open/>1. تمایز موضوع :
                        </b>
                        <div class="font-16 my-2">
                          <b-collapse id="collapse1" visible>
                            <i class="font-12">(پیشنهادی)</i>
                            <div>
                              <p class="font-16">
                                آیا دوره دیگری با حیطه موضوعی مشابه، سطح دشواری یا نوع تدریس وجود دارد ؟
                                <span
                                  class="font-14"
                                >(اگر اینطور است برای بهتر دیده شدن دوره شما، تمایز بیشتری در دوره خود در نظر بگیرید)</span>
                              </p>
                            </div>
                          </b-collapse>
                        </div>
                      </li>
                      <li>
                        <b v-b-toggle.collapse2>
                          <toggle-open/>2. اهداف دوره :
                        </b>
                        <b-collapse id="collapse2">
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>در فرم تعریف دوره، در قسمت "اهداف دوره" به سوالات زیر پاسخ دهید :</p>
                            <br>
                            <p>- دانش آموزان چه چیزی خواهند آموخت</p>
                            <p>- مخاطبین دوره</p>
                            <p>- پیش نیازهای دوره</p>
                          </div>
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>مشخص کنید چرا دوره شما برای مخاطبین مفید است. علاوه بر موضوعاتی که مخاطبین درباره آن می آموزند بر روی مهارت هایی که مخاطبین کسب خواهند کرد تمرکز کنید.</p>
                          </div>
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>از اصطلاحات عمومی استفاده نکنید، برای مثال این دوره برای "همه" مناسب است.</p>
                          </div>
                          <i class="font-12">(پیشنهادی)</i>
                          <div class="font-16 my-2">
                            <p>با توضیح اینکه دوره شما برای چه مخاطبینی مناسب می‌باشد و یا نمی‌باشد، توقعات واقع بینانه در مخاطبین ایجاد نمایید.</p>
                          </div>
                          <i class="font-12">(پیشنهادی)</i>
                          <div class="font-16 my-2">
                            <p>در مورد اینکه مخاطبین قبل از ثبت نام در دوره لازم است چه چیزهایی را بدانند توضیحات مختصری دهید.</p>
                          </div>
                        </b-collapse>
                      </li>

                      <li>
                        <b v-b-toggle.collapse3>
                          <toggle-open/>3. ساختار تدریس :
                        </b>
                        <b-collapse id="collapse3">
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>هر دوره باید شامل مقدمه ای باشدکه در آن به مخاطبین توضیح داده شود که چه مطالبی را از دوره خواهند آموخت و در ادامه برنامه ریزی نحوه آموزش دوره ارائه گردد.</p>
                          </div>
                          <i class="font-12">(پیشنهادی)</i>
                          <div class="font-16 my-2">
                            <p>در اولین جلسه دوره با پرداختن به نکات حائز اهمیت محتوای آموزشی دوره تان ، ارزش حقیقی کارتان را مشخص نمایید. هر چه در جلسات ابتدایی تر به این موضوع بپردازید، بهتر است.</p>
                          </div>
                          <i class="font-12">(پیشنهادی)</i>
                          <div class="font-16 my-2">
                            <p>در هر جلسه باید به یکی از اهداف دوره تان بپردازید و به یک مهارت خاص اختصاص داده شود. (هر جلسه می تواند یک فصل باشد.)</p>
                          </div>
                          <i class="font-12">(پیشنهادی)</i>
                          <div class="font-16 my-2">
                            <p>هر درس باید به یک مفهوم اشاره کند (فقط یک مفهوم) (مجموع چند درس می تواند یک فصل را تشکیل دهد)</p>
                          </div>
                        </b-collapse>
                      </li>
                      <li>
                        <b v-b-toggle.collapse4>
                          <toggle-open/>4. فعالیت های تمرینی :
                        </b>
                        <b-collapse id="collapse4">
                          <i class="font-12">(پیشنهادی)</i>
                          <div class="font-16 my-2">
                            <p>هر جلسه از دوره باید شامل فعالیت های تمرینی (مانند امتحان، تمرین یا پروژه) باشد تا به مخاطب در بکاربردن آنچه که در این جلسه آموخته است کمک شود.</p>
                          </div>
                          <i class="font-12">(پیشنهادی)</i>
                          <div class="font-16 my-2">
                            <p>تمام منابع مورد نیاز برای هر تمرین عملی را فراهم کنید (مانند برگه های تمرین، کد های لازم، فایل های تمرینی و غیره)</p>
                          </div>
                        </b-collapse>
                      </li>
                      <li>
                        <b v-b-toggle.collapse5>
                          <toggle-open/>5. قالب درس :
                        </b>
                        <b-collapse id="collapse5">
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>برای ایجاد ارتباط بهتر و اعتمادسازی در مخاطبین هر درس را با مقدمه ای شروع نمایید.</p>
                          </div>
                          <i class="font-12">(پیشنهادی)</i>
                          <div class="font-16 my-2">
                            <p>برای دوره های تکنیکی* بخش های آموزشی دوره باید توسط یک نرم افزار ضبط ویدئو از صفحه نمایش (دسکتاپ) بصورت فیلم درآورده شود. (دوره های تکنیکی دوره هایی هستند که کسب مهارت بستگی به کار با کامپیوتر دارد مانند آموزش نرم افزار وغیره)</p>
                          </div>
                          <i class="font-12">(پیشنهادی)</i>
                          <div class="font-16 my-2">
                            <p>بجز دوره های تکنیکی در سایر دوره ها حداقل 20% از کل دوره را به گفتگو اختصاص دهید.</p>
                          </div>
                        </b-collapse>
                      </li>
                      <li>
                        <b v-b-toggle.collapse6>
                          <toggle-open/>6. صدا :
                        </b>
                        <b-collapse id="collapse6">
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>صدا باید عاری از نویز های مزاحم مانند: اکو شدن صدا، انفحار هوا در اصوات "پ" و "ت"، همهمه پس زمینه و گنگ بودن صدا باشد.</p>
                          </div>
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>صدا باید دوکاناله باشد و با ویدئو تطبیق داشته باشد.</p>
                          </div>
                        </b-collapse>
                      </li>

                      <li>
                        <b v-b-toggle.collapse7>
                          <toggle-open/>7. تصویر :
                        </b>
                        <b-collapse id="collapse7">
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>ویدئو باید بصورت HD (حداقل 720P ) و با نور کافی و زاویه بندی مناسب و توسط یک دوربین ثابت</p>
                          </div>
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>ویدئو باید بصورت HD (حداقل 720P ) و با نور کافی و زاویه بندی مناسب و توسط یک دوربین ثابت فیلمبرداری گردد.</p>
                          </div>
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>اسلاید ها، صفحه نمایش (دسکتاپ) یا سایر اجزای دیداری باید واضح باشند و خواندن آنها راحت باشد. (پیکسلی یا تار نباشد)</p>
                          </div>
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>حداقل 60% ارائه یک درس باید ویدئو باشد.</p>
                          </div>
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>مدرس یا موضوع درس باید بر روی تصویر بوضوح قابل دیدن باشد.</p>
                          </div>
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>در تمامی دروس تغییرات باید یکدست و استاندارد باشند. (شامل نحوه تغییر اسلاید ها و حرکت های آنها)</p>
                          </div>
                          <i class="font-12">(پیشنهادی)</i>
                          <div class="font-16 my-2">
                            <p>از تمام ویدئو ها با فرمت 16:9 خروجی بگیرید.</p>
                          </div>
                          <i class="font-12">(پیشنهادی)</i>
                          <div class="font-16 my-2">
                            <p>از متن به قدر کافی بزرگ استفاده کنید تا در تمام دستگاه ها به راحتی خوانده شود</p>
                          </div>
                        </b-collapse>
                      </li>

                      <li>
                        <b v-b-toggle.collapse8>
                          <toggle-open/>8. ارائه مطالب توسط مدرس :
                        </b>
                        <b-collapse id="collapse8">
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>از صداهای "اممم" و " اححح" هنگام سخن گفتن استفاده نکنید و محکم سخن بگویید. مخاطبین مدرسینی را می خواهند که صریح، آگاه و با اعتماد به نفس هستند.</p>
                          </div>
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>بر روی ارائه مطالب با یک تون صدای علاقمند کار کنید. دوربین بخشی از علاقمندی و اشتیاق شما را از بین می برد. بنابراین هنگام فیلم گرفتن از ارائه تان 110% اشتیاق نشان دهید.</p>
                          </div>
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>کلمات را بطور واضح تلفظ کنید و بر روی نکات مهم تاکید کنید.</p>
                          </div>
                        </b-collapse>
                      </li>
                      <li>
                        <b v-b-toggle.collapse9>
                          <toggle-open/>9. ویدئو معرفی (تبلیغاتی) :
                        </b>
                        <b-collapse id="collapse9">
                          <i class="font-12">(پیشنهادی)</i>
                          <div class="font-16 my-2">
                            <p>برای جذب بهتر مخاطبین یک ویدئو معرفی داشته باشید.</p>
                          </div>
                          <i class="font-12">(پیشنهادی)</i>
                          <div class="font-16 my-2">
                            <p>از این ویدئو برای انعکاس صحیح تجربه دوره استفاده کنید و در آن مضامینی همچون موضوع دوره، اهداف دوره، و شیوه تدریس را بگنجانید.</p>
                          </div>
                        </b-collapse>
                      </li>
                      <li>
                        <b v-b-toggle.collapse10>
                          <toggle-open/>10. بیوگرافی مدرس :
                        </b>
                        <b-collapse id="collapse10">
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>برای مشخص کردن پیشینه، تجربه و اعتبار خود در زمینه مربوطه، بیوگرافی مدرس را کامل نمایید.</p>
                          </div>
                        </b-collapse>
                      </li>
                      <li>
                        <b v-b-toggle.collapse11>
                          <toggle-open/>11. قیمت :
                        </b>
                        <b-collapse id="collapse11">
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>دوره ها باید 10 هزار تا 500 هزار تومان با نرخ افزایش 5 هزار تومانی قیمت گذاری شوند.</p>
                          </div>
                          <i class="font-12">(پیشنهادی)</i>
                          <div class="font-16 my-2">
                            <p>قیمت دوره می تواند بر اساس ساعت دوره تنظیم گردد.</p>
                          </div>
                          <i class="font-12">(پیشنهادی)</i>
                          <div class="font-16 my-2">
                            <p>قیمت دوره باید با دوره های دیگری که موضوع، طول محتوا یا شیوه تدریس مشابه دارند همسان باشد.</p>
                          </div>
                        </b-collapse>
                      </li>
                      <li>
                        <b v-b-toggle.collapse12>
                          <toggle-open/>12. عنوان/زیر عنوان :
                        </b>
                        <b-collapse id="collapse12">
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>عنوان دوره باید تمام محتوای دوره شما را پوشش دهد.</p>
                          </div>
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>زیر عنوان باید بدون تکرار عنوان ساخته شود.</p>
                          </div>
                        </b-collapse>
                      </li>
                      <li>
                        <b v-b-toggle.collapse13>
                          <toggle-open/>13. خلاصه دوره :
                        </b>
                        <b-collapse id="collapse13">
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>خلاصه ای از آنچه دوره شما پوشش می دهد، چگونه باید آن را آموخت، مخاطبین چه چیزی یاد خواهند گرفت و آنچه از دوره بدست خواهند آورد، ارائه کنید. برای بهبود میزان فروش پیشنهادات ما را بکار بگیرید.</p>
                          </div>
                        </b-collapse>
                      </li>

                      <li>
                        <b v-b-toggle.collapse14>
                          <toggle-open/>14. تصویر دوره :
                        </b>
                        <b-collapse id="collapse14">
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>تصویر دوره باید حداقل 16:9; 2048 x 1152 pixels و با یکی از فرمت های .jpg, .jpeg, .gif, .png, .bmpباشد.</p>
                          </div>
                        </b-collapse>
                      </li>

                      <li>
                        <b v-b-toggle.collapse15>
                          <toggle-open/>15. شرح درس :
                        </b>
                        <b-collapse id="collapse15">
                          <i class="font-12">(پیشنهادی)</i>
                          <div class="font-16 my-2">
                            <p>یک شرح دقیق و جزئی از آنچه هر درس پوشش می دهد تهیه کنید.</p>
                          </div>
                        </b-collapse>
                      </li>
                      <li>
                        <b v-b-toggle.collapse16>
                          <toggle-open/>16. اتمام دوره :
                        </b>
                        <b-collapse id="collapse16">
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>100% محتواهای دوره برای اتمام و انتشار دوره لازم است.</p>
                          </div>
                        </b-collapse>
                      </li>
                      <li>
                        <b v-b-toggle.collapse17>
                          <toggle-open/>17. دوره هایی که مدرس اثر نیستید. :
                        </b>
                        <b-collapse id="collapse17">
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>برای انتشار دوره هایی که شما تولید نکرده اید و از مدرس خریداری نموده اید نیاز به بررسی بیشتری توسط ما وجود دارد. پس با ما تماس بگیرید.</p>
                          </div>
                        </b-collapse>
                      </li>
                      <li>
                        <b v-b-toggle.collapse18>
                          <toggle-open/>18. دوره های غیر مفید :
                        </b>
                        <b-collapse id="collapse18">
                          <i class="font-12">(ضروری)</i>
                          <div class="font-16 my-2">
                            <p>اجازه انتشار دوره های غیر مفید که بار آموزشی ندارند، وجود ندارد.</p>
                          </div>
                        </b-collapse>
                      </li>
                    </ul>
                  </div>
                </b-tab>
               
              </b-tabs>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import toggleOpen from "cp/min-component/open-colose.vue";

export default {
  name: "page-dashbord-rules",
  components: {
    toggleOpen
  },
  data() {
    return {
      tabIndex: 0,
    }
  },
   watch: {
    $route(to, from) {
      if (this.$route.query && this.$route.query.tabActive) {
        this.tabIndex = parseInt(this.$route.query.tabActive);
      }
    }
  },
  mounted() {
    if (this.$route.query && this.$route.query.tabActive) {
      this.tabIndex = parseInt(this.$route.query.tabActive);
    }
  },
};
</script>

<style lang="less">
@import (reference) "../../assets/css/variable.less";
.page-dashbord-rules {
  .nav-pills .nav-link.active,
  .nav-pills .show > .nav-link {
    background-color: @green !important;
  }
  .nav {
    justify-content: center;
  }
  .box-clear;
  .tabs-about-madya {
    .lis-tabs-standard {
      li {
        b {
          cursor: pointer;
        }
        border-bottom: 1px solid #e3e3e3;
        padding: 10px 0;
        .font-16.my-2 {
          border-bottom: 1px solid rgba(224, 224, 224, 0.37);
          padding: 0 10px;
          &:last-child {
            border: none;
          }
        }
      }
    }
    .nav-tabs .nav-link {
      color: @primaryTextColor;
    }
    .nav-tabs .nav-item.show .nav-link,
    .nav-tabs .nav-link.active {
      color: @secondaryTextColor;
    }
  }
  .description-tab {
      p {
        color: #000;
      }
      ul {
        padding-right: 25px;
        li {
          span {
            background-color: #fff2ac;
            background-image: linear-gradient(to right, #ffe359 0%, #fff2ac 100%);
          }
          margin-bottom: 10px;
          list-style: arabic-indic;
        }
      }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/min-component/helpmadya.vue